'use client';
import {
  getChainFromSlug,
  getNetworkFromChainSlug,
  normalizeChainSlug,
} from '@/domain/network';
import { createContext, ReactNode, useContext, useMemo } from 'react';
import { Chain, mainnet } from 'wagmi';

export const NetworkContext = createContext<{
  slug: string;
  network: number;
  chain: Chain;
}>({
  slug: 'eth',
  network: 1,
  chain: mainnet,
});

export const NetworkProvider = ({
  slug,
  children,
}: {
  slug: string;
  children: ReactNode;
}) => {
  const value = useMemo(
    () => ({
      slug: normalizeChainSlug(slug),
      network: getNetworkFromChainSlug(slug),
      chain: getChainFromSlug(slug),
    }),
    [slug]
  );

  return (
    <NetworkContext.Provider value={value}>{children}</NetworkContext.Provider>
  );
};

export const useNetwork = () => useContext(NetworkContext);
